import React, { Component } from "react";
import { Switch, Route, NavLink } from "react-router-dom";
import Pending from "./Pending";
import Requested from "./Requested";
import Create from "./Create";
import KeyDropdownValue from "../shared/KeyDropdownValue";
import { withRouter } from "react-router";
import CustomButton from "../shared/CustomButton";
import Modal from "../shared/Modal";
import { ArrowLeftRight } from "../normalizer";

class SaleTrade extends Component {
  state = { showCreateModal: false };

  dropNavOptions = [
    {
      label: "Atribuição de contrato",
      to: "/sale-attributions/pending",
    },
    {
      label: "Troca de contrato",
      to: "/sale-trading/requested",
    },
  ];

  handleDropdownChange = (option) => {
    this.props.history.push(option.to);
  };

  openCreateModal = () => this.setState({ showCreateModal: true });
  closeCreateModal = () => this.setState({ showCreateModal: false });

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ showCreateModal: false });
    }
  }

  render() {
    const { history } = this.props;

    return (
      <div className="contracts-layout">
        <div className="contracts-layout-header">
          <h4 className="contracts-layout-header-title">Contratos</h4>
        </div>
        <div className="contracts-layout-options">
          <div className="contracts-layout-options-drop">
            <KeyDropdownValue
              className="contracts-layout-options-drop-select"
              options={this.dropNavOptions}
              optionsLabel="label"
              optionsId="to"
              selectedValue={this.dropNavOptions[1]}
              onChange={this.handleDropdownChange}
              placeholder="Selecione"
            />
          </div>
          <div className="contracts-layout-options-btn">
            <CustomButton 
              className="contracts-layout-options-btn-element"
              secondary
              onClick={this.openCreateModal}
            >
              <ArrowLeftRight className="contracts-layout-options-btn-icon" />
              Novo pedido
            </CustomButton>
          </div>
        </div>
        <nav className="contracts-layout-navigation">
          <NavLink
            exact
            to={"/sale-trading/requested"}
            activeClassName="contracts-layout-navigation-item-active"
            className="contracts-layout-navigation-item"
          >
            Os meus pedidos
          </NavLink>
          <NavLink
            exact
            to={"/sale-trading/pending"}
            activeClassName="contracts-layout-navigation-item-active"
            className="contracts-layout-navigation-item"
          >
            Pedidos recebidos
          </NavLink>
        </nav>
        <Switch>
          <Route path="/sale-trading/pending" component={Pending} />
          <Route path="/sale-trading/requested" component={Requested} />
        </Switch>

        <Modal
          show={this.state.showCreateModal}
          untoggle={this.closeCreateModal}
        >
          <Create history={history} onClose={this.closeCreateModal} />
        </Modal>
      </div>
    );
  }
}
export default withRouter(SaleTrade);
